var NotificationSubscriptionCategory;
(function (NotificationSubscriptionCategory) {
    NotificationSubscriptionCategory["SYSTEM_RULE"] = "system_rule";
    NotificationSubscriptionCategory["MEASUREMENT_RULE"] = "measurement_rule";
})(NotificationSubscriptionCategory || (NotificationSubscriptionCategory = {}));
export default NotificationSubscriptionCategory;
